import { createBrowserRouter } from "react-router-dom";

import App from "components/App";
import HomePage from "pages/HomePage";
import { AccountNotFoundPage } from "pages/AccountNotFoundPage";
import MinimalLayout from "layouts/minimalLayout";
import { UnauthorizedPage } from "pages/InvalidStatePages/UnauthorizedPage";
import { ErrorPage } from "pages/InvalidStatePages/ErrorPage";
import { NotFoundPage } from "pages/InvalidStatePages/NotFoundPage";

import { usersRoutes } from "./users.routes";
import { contentRoutes } from "./content.routes";
import { configurationRoutes } from "./configuration.routes";
import { certificatesRoutes } from "./certificates.routes";
import { accreditationRoutes } from "./accreditation.routes";
import { eventsRoutes } from "./events.routes";
import { operationsRoutes } from "./operations.routes";

export const router = createBrowserRouter([
  {
    element: <MinimalLayout />,
    children: [
      { path: "/no-account", element: <AccountNotFoundPage /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "home", element: <HomePage /> },
      { path: "users", children: usersRoutes },
      { path: "content", children: contentRoutes },
      { path: "configuration", children: configurationRoutes },
      { path: "certificates", children: certificatesRoutes },
      { path: "accreditation", children: accreditationRoutes },
      { path: "events", children: eventsRoutes },
      { path: "operations", children: operationsRoutes },
      { path: "unauthorized", element: <UnauthorizedPage /> },
      { path: "error", element: <ErrorPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
